import { Operator, OperatorAndValue } from 'components/shared/TableFilters'

export function filter(
	column: string,
	operator: Operator,
	value: string
): Record<string, Partial<OperatorAndValue>> {
	return {
		[column]: {
			[operator]: value,
		},
	}
}
